<template>
  <div class="wrapper">
    <div class="user-block">
      <div class="user-info">
        <div class="div-block">
          {{$t('hi')}}
          <span class="name theme">{{userInfo.email || userInfo.nickname || ''}}</span>，Welcome to Sanlida Archery
        </div>
        <!-- <div class="div-block jf">
          <div class="jf-l">
            {{$t('current')}} {{$t('integral')}}
            <span class="level theme">{{userInfo.point}}</span>
            <a
              href="javascript:;"
              class="sign"
              @click="sign"
              :class="isSign?'has':''"
            >{{isSign ? $t('checkedIn'): $t('signIn')}}</a>
          </div>
        </div> -->
				<!-- <div class="div-block">
					<span>My Affiliate Link: &nbsp;&nbsp;{{ shareUrl }}</span>
					<span class="sharecode" @click="shareDia = true">custom</span>
				</div> -->
        <div class="div-block">
          {{$t('balance')}}：
          <span>{{$t('currencySymbol')}} {{userInfo.balance}}</span>
        </div>
      </div>
      <div class="order-status">
        <div>{{$t('tips')}}:</div>
        <div class="item" v-for="(item,index) in orderNumsArr" :key="index">
          <router-link :to="{name:'myOrder',query:{type:index+1}}">
            {{item.name}}
            <span class="num" :class="item.value>0?'active':''">{{item.value}}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="order-wrap">
      <div class="order-head title">
        Orders
        <router-link :to="{name:'myOrder'}" class="btn">
          All Order »
          <!-- {{$t('all')}}{{$t('order',  {prefix: '', text: ''})}}» -->
        </router-link>
      </div>
      <div class="order-list-wrap">
        <div class="order-head order-box" v-if="orderInfo.length==0" style="padding-left:30px;">{{$t('noData')}}</div>
        <div class="order-head order-box" v-else>
          <div class="order-info">Products</div>
          <div class="order-price">Unit</div>
          <div class="order-num">{{$t('nums')}}</div>
          <div class="order-total-price">{{$t('goodsTotal')}}</div>
          <div class="order-state">Status</div>
          <div class="order-handle">Check Out</div>
        </div>
        <div class="order-item" v-for="(order,index) in orderInfo" :key="index">
          <div class="order-item-head">
            <span class="time">{{orderTime(order.ctime)}}</span>
            {{$t('order', {text: $t('number')})}}：
            <span class="code">{{order.order_id}}</span>
          </div>
          <div class="order-item-main order-box">
            <div class="order-info-list">
              <div class="order-li" v-for="(product,i) in order.items" :key="i">
                <img :src="product.image_url" alt class="order-img">
                <div class="order-name">{{product.name}}</div>
                <div class="order-price">{{$t('currencySymbol')}} {{product.price}}</div>
                <div class="order-num">
                  <i class="icon iconfont iconchenghao">{{product.nums}}</i>
                </div>
              </div>
            </div>
            <div class="order-total-price">{{$t('currencySymbol')}} {{order.order_amount}}</div>
            <div class="order-state">
              <div class="order-status">{{getOrderStatus(order)}}</div>
              <router-link
                :to="{name:'orderDetail',params:{order_id:order.order_id}}"
                class="order-detail-link"
                tag="a"
              >{{$t('order', {text: $t('detail')})}}</router-link>
            </div>
            <div class="order-handle">
              <template v-if="order.status === 1 && order.pay_status === 1">
                <router-link :to="{name:'cashier',params:{order_id:order.order_id}}">{{$t('toPay')}}</router-link>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 1"
              >
                <span @click="tackDelivery(order.order_id)">{{$t('receiving')}}</span>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 2 && order.is_comment === 1"
              >
                <router-link :to="{name:'evaluate',query:{order_id:order.order_id}}">{{$t('evaluate')}}</router-link>
              </template>
              <template v-else>
                <span>
                  <router-link :to="{name:'detail',params:{goodsId:order.items[0].goods_id}}">{{$t('toPay')}}</router-link>
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order-wrap">
      <div class="order-head title">
        <!-- 最近收藏 -->
        {{$t('collection')}}
        <router-link :to="'favourite'" class="btn">
          All Collection »
        </router-link>
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in favList" :key="index">
          <div class="img-wrap">
            <img :src="item.goods.image_url" :alt="item.goods_name">
          </div>
          <div class="title">{{item.goods_name}}</div>
          <div class="price">${{item.goods.price}}</div>
          <div class="actions">
            <a href="javascript:;" class="del" @click="delCollete(item.goods_id,index)">{{$t('del')}}</a>
            <a href="javascript:;" class="detail" @click="lookDetail(item.goods_id)">{{$t('detail')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="favList.length==0" style="padding-left:20px;color:#757575;font-size:12px;">{{$t('noData')}}</div>
		<el-dialog :visible.sync="shareDia" width="600px" title="Set custom sharing code" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<div>
				<div class="adress-form">
					<div class="form-section">
					  <input
					    type="text"
					    placeholder="Please enter the sharing code"
					    class="input-text input-control"
					    v-model="share_code"
					  >
					  <label for class="input-label">My Code</label>
					</div>
				</div>	
				<div class="form-foot">
					<div class="foot-btn cancel" @click="shareDia = false">Close</div>
					<div class="foot-btn save" @click="setShare">{{ $t('setting') }}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { timeToDate } from "@/utils";
import storage from "@/utils/storage";
import { apiBaseUrl } from "@/config/env.js";
export default {
  name: "User",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
			apiBaseUrl,
      isSign: false,
			shareDia: false,
      orderNumsArr: [
        {
          name: this.$t('obligation'),
          value: 0
        },
        {
          name: this.$t('pending'),
          value: 0
        },
        {
          name: this.$t('waitForReceiving'),
          value: 0
        },
        {
          name: this.$t('waitForEvaluate'),
          value: 0
        }
      ],
      orderInfo: [],
      favList: [],
			shareUrl: '',
			share_code: ''
    };
  },
  watch: {},
  computed: {
    orderTime() {
      return time => {
        return timeToDate(time);
      };
    },
    //获取订单状态文字显示
    getOrderStatus() {
      return order => {
        let orderStatusName;
        switch (order.status) {
          case 1:
            if (order.pay_status === 1) {
              orderStatusName = this.$t('obligation');
            }
            if (order.pay_status === 2 && order.ship_status === 1) {
              orderStatusName = this.$t('pending');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 1
            ) {
              orderStatusName = this.$t('waitForReceiving');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 1
            ) {
              orderStatusName = this.$t('waitForEvaluate');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 2
            ) {
              orderStatusName = this.$t('haveEvaluation');
            }
            if (order.pay_status === 4) {
              orderStatusName = this.$t('afterSaleList');
            }
            break;
          case 2:
            orderStatusName = this.$t('finished');
            break;
          case 3:
            orderStatusName = this.$t('cancel');
            break;
        }
        return orderStatusName;
      };
    }
  },
  methods: {
		setShare() {
			const _this = this
			this.$api.shareCusCode({share_code: this.share_code}).then(res => {
			  if (res.status) {
					this.shareDia = false
					this.getShareUrl()
					_this.$msg(this.$t('setSuccess'));
			  }else{
					_this.$msg(_this.$t('failed'))
				}
			})
		},
		getShareUrl() {
			let data={
				client: 5,
				page: 1,
				type: 1,
				url: '/jump'
			}
			let userToken = storage.get("userToken");
			if(userToken) {
				data.token = userToken
			}
			const _this = this
			this.$api.share(data).then(res => {
			  if (res.status) {
					let url = res.data
			    _this.shareUrl = _this.apiBaseUrl.slice(0, -1) + url
			  }else{
					_this.$msg(_this.$t('getUrlFailed'))
				}
			})
		},
    getLatestOrder() {
      //最近一个订单
      let data = {
        page: 1,
        limit: 1,
        status: 0
      };
      this.$api.orderList(data).then(res => {
        if (res.status) {
          this.orderInfo = res.data.list;
        }
      });
    },
    getFavList() {
      let data = {
        page: 1,
        limit: 4
      };
      this.$api.goodsCollectionList(data).then(res => {
        if (res.status) {
          this.favList = res.data.list;
        }
      });
    },
    getOrderNums() {
      this.$api.getOrderStatusSum().then(res => {
        if (res.status) {
          let data = res.data;
          this.orderNumsArr.forEach((item, index) => {
            item.value = data[index + 1];
          });
        }
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.$storage.set("userInfo", result.data);
          this.userInfo = result.data;
        }
      });
    },
    checkIsSign() {
      this.$api.isSign().then(res => {
        if (res.status) {
          this.isSign = true;
        }
      });
    },
    sign() {
      if (this.isSign) return;
      this.$api.sign().then(res => {
        if (res.status) {
          this.isSign = true;
          this.getUserInfo();
        }
      });
    },
    delCollete(id, index) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
          this.$nextTick(() => {
            this.favList.splice(index, 1);
          });
        }
      });
    },
    lookDetail(id) {
      this.$router.push({ name: "detail", params: { goodsId: id } });
    }
  },
  created() {
    this.getUserInfo();
    this.checkIsSign();
    this.getOrderNums();
    this.getLatestOrder();
    this.getFavList();
		this.getShareUrl();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
@import "./Favourite.scss";
.wrapper {
  .user-block {
    border: 1px solid $border;
    margin-bottom: 15px;
    .user-info {
      padding: 20px;
      .div-block {
        line-height: 30px;
        &.jf {
          display: flex;
          .jf-l {
            margin-right: 100px;
          }
        }
        span.theme {
          color: $theme-color;
        }
        span.level {
          margin: 0 5px;
        }
				.sharecode {
					margin-left: 20px;
					color: blue;
					cursor: pointer;
				}
        .sign {
          display: inline-block;
          margin-left: 15px;
          min-width: 60px;
          height: 24px;
          line-height: 24px;
          color: #fff;
          background: $theme-color;
          text-align: center;
          padding: 0 6px;
          &.has {
            background: #b0b0b0;
            cursor: no-drop;
          }
        }
        .save {
          margin-left: 20px;
          color: #757575;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }
    .order-status {
      height: 45px;
      display: flex;
      align-items: center;
      border-top: 1px solid $border;
      padding: 0 20px;
      .item {
        padding-left: 20px;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        .num {
          display: inline-block;
          width: 18px;
          height: 18px;
          line-height: 18px;
          border-radius: 2px;
          background: #b0b0b0;
          text-align: center;
          color: #fff;
          &.active {
            background: $theme-color;
          }
        }
      }
    }
  }
  .order-wrap {
    border: 1px solid $border;
    margin-bottom: 15px;
    .order-head {
      height: 40px;
      line-height: 40px;
      background: #fff;
      color: #757575;
      box-sizing: border-box;
      &.title {
        text-indent: 20px;
      }
      .btn {
        margin-right: 30px;
        float: right;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
}
.order-item {
  box-sizing: border-box;
  .order-item-head {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #757575;
    padding-left: 20px;
    border-bottom: 1px solid $border;
    .time {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 500px;
      .order-li {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }
        .order-name {
          width: 200px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    // margin: 20px 0;
  }
  .order-info {
    width: 310px;
    text-indent: 20px;
  }
  .order-price {
    width: 100px;
    text-align: center;
  }
  .order-num {
    width: 90px;
    text-align: center;
    .icon {
      font-size: 12px;
    }
  }
  .order-total-price {
    width: 120px;
    text-align: center;
  }
  .order-state {
    width: 150px;
    text-align: center;
    .order-status {
      margin-bottom: 10px;
    }
    .order-detail-link {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .order-handle {
    width: 150px;
    text-align: center;
    span,
    a {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }
  }
}
.like-list {
  display: flex;
  flex-flow: row wrap;
  padding-top: 15px;
  .like-item {
    text-align: center;
    margin-left: 20px;
    margin-bottom: 15px;
    a {
      display: block;
    }
    .like-img {
      width: 150px;
      height: 150px;
      border: 1px solid $border;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .title {
      height: 30px;
      line-height: 30px;
      &:hover {
        color: $theme-color;
      }
    }
    .price {
      color: $theme-color;
    }
  }
}
.adress-form {
  width: 580px;
  margin: 0 auto;
  padding: 30px 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-content: flex-start;
	.form-section {
    position: relative;
    margin-bottom: 15px; 
		.input-control {
		  margin: 0;
		  font-size: 14px;
		  line-height: 1.5;
		  outline: none;
		  padding: 10px 16px;
		  border: 1px solid #e0e0e0;
		  transition: border-color 0.25s linear;
		  &.input-text {
		    height: 18px;
		    line-height: 18px;
		  }
		  &:focus {
		    border-color: $theme-color;
		  }
		  &:placeholder-shown::placeholder {
		    color: transparent;
		  }
		  &:not(:placeholder-shown)::placeholder,
		  &:focus::placeholder {
		    color: #b0b0b0;
		  }
		  /* 线框样式label定位 */
		  &:not(:placeholder-shown) ~ .input-label,
		  &:focus ~ .input-label {
		    color: $theme-color;
		    transform: scale(0.75) translate(-2px, -24px);
		  }
		}
		.input-text {
		  width: 540px;
		}
		.input-textarea {
		  width: 100%;
		  box-sizing: border-box;
		  resize: none;
		}
		.input-label {
		  position: absolute;
		  font-size: 16px;
		  line-height: 1.5;
		  left: 16px;
		  top: 8px;
		  color: #b0b0b0;
		  background: #fff;
		  padding: 0 2px;
		  transform-origin: 0 0;
		  pointer-events: none;
		  transition: all 0.25s linear;
		  display: none\0;
		}
	}	
}	
.form-foot {
	display: flex;
	justify-content: center;
	padding: 20px 0;
	background: #f5f5f5;
	.foot-btn {
		width: 160px;
		text-align: center;
		height: 40px;
		line-height: 40px;
		color: #fff;
		cursor: pointer;
		&.save {
			background: $theme-color;
			margin-right: 20px;
			margin-left: 20px;
		}
		&.cancel {
			background: #b0b0b0;
			transition: all 0.2s;
			&:hover {
				background: #757575;
			}
		}
	}
}
</style>